/*========================================================================
* $Id: emailalert.js 91712 2016-07-06 15:14:22Z daniel.eppensteiner $
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2014
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define([
  "client/template",
  "i18n/i18n",
  "component!base",
  "component!treeview",
  "client/views/list",
  "api/v2/search",
  "utils/browser",
  "utils/clone",
  "utils/dom",
  "utils/url",
  "utils/mustache",
  "utils/jsonpath",
  "utils/persistedsourceinfo",
  "model/persisted_collection",
  "service/stub",
  "client/application",
  "api/v2/common",
  "utils/localStorage",
  "backbone",
  "underscore",
  "jquery",
  "model/alertcenter",
  "api/v2/persisted",
  "service/channel",
  "service/channels",
  "api/v2/resources",
  "client/resourceinfo",
  "!!raw-loader!../mustache/template.mustache",
  "!!raw-loader!../mustache/header.mustache",
  "model/grouped_collection",
  "model/persisted_collection_application_extensions"
], function (
  Template,
  i18n,
  Base,
  TreeView,
  ListView,
  Search,
  Browser,
  clone,
  dom,
  url,
  Mustache,
  JSONPath,
  PersistedSourceInfo,
  PersistedCollection,
  Stub,
  Application,
  Common,
  localStorage,
  Backbone,
  _,
  $,
  AlertModels,
  Persisted,
  Channel,
  Channels,
  Resources,
  ResourceInfo,
  DEFAULT_TEMPLATE,
  HEADER_TEMPLATE,
  GroupedCollection
) {

  var EmailAlert = Template.extend({

    initialize: function() {
      this.initializationPromise = new Channel.DeferredCallFinished();      
      Template.prototype.initialize.apply(this, _.toArray(arguments));

      //fetch alerts from owner
      var owner = this.application.models.emailAlerts.get("serviceInfo").userSourceInfo.get("user_name");
      this.getEmailAlerts(["emailalert"], owner);
    },

    getEmailAlerts: function (path, owner) {
      var that = this;
      this.application.models.emailAlerts.getAlerts({path: path, owner: owner, application: this.application}, function () {
        that.initializationPromise.triggerDone();
      }, function() {
        that.initializationPromise.triggerDone();
      });
    },

    hasContent: function () {
      return true;
    },

    model: function () {
      return new GroupedCollection([], {
        delegate: this.application.models.emailAlerts.get("alerts"),
        groupingPath: ["frequency","groupTag"],
        compareFunctions: [ function (a,b) { return a-b } ]
      });
    },

    createView: function(options) {
      var options = _.extend(this.schema.parseAttributes(this.attributeModel.getCamelCase()), options);
      return Template.prototype.createView.apply(this, [options]);
    },

    schema: new Template.Schema({
      attributes: {
        "title": {
          type: "string",
          title: "editor_user_alerts_title"
        },
        "allow-edit": {
          title: "editor_allow_edit",
          type: "boolean",
          defaultValue: true,
          "default": true,
        },
        "edit-alert-btn-title": {
          type: "string",
          title: "editor_add_new_user_title"
        }
      }
    })

  });

  EmailAlert.View = Base.extend({

    defaultOptions: {
      titleTagName: "h2"
    },

    initialize: function () {
      var that = this;
      this.options.allowEdit = this.options["allow-edit"] || true;

      $(this.el).addClass("notification_alerts");

      this.headers = '\
        <div class="mb-flexbox-container useralert-header">\
          <div class="mb-flex-element">\
            ' + i18n("title") +'\
          </div>\
          <div class="mb-flex-element">\
            ' + i18n("editor_suggest_source_query_term") +'\
          </div>\
          <div class="mb-flex-element">\
          ' + i18n("group") +'\
          </div>\
          <div class="mb-flex-element">\
            ' + i18n("client_alert_base_frequency") +'\
          </div>\
          <div class="mb-flex-element">\
          ' + i18n("alert_search_tab") +'\
          </div>\
          <div class="mb-flex-element">\
          ' + i18n("active_filters") +'\
          </div>\
          <div class="mb-flex-element">\
          ' + i18n("created") +'\
          </div>\
          <div class="mb-fix-flex-element group-headline-edit"></div>\
        </div>',

      $(this.el).prepend(this.headers);

      this.titleEl = this.make(this.options.titleTagName || this.defaultOptions.titleTagName, {
           "class": this.options.titleClassName,
           "id": "userAlerts-title-" + this.cid
         }, this.options.title ? i18n(this.options.title) : i18n("userAlerts"));

      $(this.el).prepend(this.titleEl)
      $(this.titleEl).attr("data-i18n", this.options.title || "userAlerts");

      if (this.options.allowEdit) {
        this.addButton = this.make("button", {
          "class": "addAlertBtn btn-mb-default",
          "data-action-name": "addAlert"
        }, this.options.editAlertBtnTitle ? i18n(this.options.editAlertBtnTitle) : i18n("add_new_alert") );
        $(this.addButton).attr("data-i18n", this.options.editAlertBtnTitle || "add_new_alert");
        $(this.el).prepend(this.addButton);
      }

      this.options.application.models.emailAlerts.getFrequency(["emailalert"], function () {}, function() {}); //callback, errback?
      this.options.application.models.emailAlerts.getUser(["user","default"], function () {}, function() {}); //callback, errback?

      this.options.application.models.emailAlerts.getSchemaByPath(["emailalert"], this.options.application, function (response) {
        var property_definitions = response && response.property_definitions;
        var referenced_notification = _.find(property_definitions, function (property) {
          return property.key == "referenced_notification";
        });

        var reference_target_collection_path = referenced_notification && referenced_notification.reference_target_collection_path;
        if (reference_target_collection_path) {
          that.options.application.models.emailAlerts.getACL(reference_target_collection_path, function () {
            //set admin or user
            var acl = that.options.application.models.emailAlerts.get("acl");
            var useradmin = acl.get("operations").operations.indexOf("CREATE_ENTRY") >= 0 ? true : false;
            if (useradmin) $('body').addClass("useradmin")
          }, function() {}); //callback, errback?
        }

      }, function() {}); //callback, errback?

    },

    remove: function (options) {
      //what else?
      Backbone.View.prototype.remove.apply(this, arguments);
    }

  });

  Application.prototype.addAlert = function (options) {
    options.event.preventDefault();
    this.alertsStackManager(options);
  };

  Application.prototype.alertsStackManager = function (options) {
    var acl = this.models.emailAlerts.get("acl");
    var useradmin = acl.get("operations").operations.indexOf("CREATE_ENTRY") >= 0 ? true : false;

    var stackTitleClass = "",
        client_add_or_update_notifications = "client_add_notifications",
        user = this.models.emailAlerts.get("user") && this.models.emailAlerts.get("user").get("properties") ||
          this.models.emailAlerts.get("user").at(0) && this.models.emailAlerts.get("user").at(0).get("properties"),
        user_name = this.models.userSourceInfo.get("user_name"),
        email = user && user.email,
        user = user && user.user;

    var applicationOptions = {
      "startSearch": false,
      "user_name": user_name,
      "user": user,
      "email": email,
      "el": "mb-add-notification-stack"
    }

    applicationOptions.properties = {};
    applicationOptions.properties.model = options.model;

    if (options.edit) {
      stackTitleClass += "edit";
      applicationOptions.properties.edit = true;
      if (options.referenced_path) {
        stackTitleClass += " subscribe";
        applicationOptions.properties.referenced_notification_available = true;
        client_add_or_update_notifications = "client_notification_update_abo_notifications_template";
      } else {
        client_add_or_update_notifications = "client_notification_update_notifications_template";
      }
    } else if (options.subscribe) {
      stackTitleClass += "subscribe";
      client_add_or_update_notifications = "client_notification_subscribe_notifications_template";
      applicationOptions.properties.subscribe = true;
    } else if (options.duplicate) {
      stackTitleClass += "duplicate";
      applicationOptions.properties.duplicate = true;
    } else if (options.editSubscribed) {
      stackTitleClass += "adminEditSubscription";
      client_add_or_update_notifications = "client_notification_update_abo_notifications_template";
      applicationOptions.properties.subscribe = true;
      applicationOptions.properties.editSubscription = true;
    } else {
      applicationOptions.userQuery = this.parentApplication.getUnparsedUserQuery();
      delete applicationOptions.properties;
    }

    if (useradmin) stackTitleClass += " useradmin";

    //TODO remove from title
    var stackTitle = "<div id='mb-add-notification-stack' class='" + stackTitleClass + "'><div class='mb-stack-title-group-notification' data-i18n=" + client_add_or_update_notifications + "></div>" + (HEADER_TEMPLATE && HEADER_TEMPLATE.default) + "</div>";

    var rootElement = this.parentApplication && this.parentApplication.rootElsClone || this.rootElsClone;
    if (rootElement.id) {
      var templateRefID = rootElement.id;
    } else {
      var templateRefID = rootElement;
    }

    $('body').addClass("mb-add-alert");
    var $templateRefID = $(templateRefID);

    //remove unused templates
    $templateRefID.find("[data-template='profilesettings']").remove();
    $templateRefID.find("#notifications").remove();

    this.pushStack({
      "title": stackTitle,
      "template-ref": templateRefID,
      "useRootElement": true,
      "action": "runSavedAlertSearch",
      "applicationOptions": applicationOptions
    });
  };

  Application.prototype.runSavedAlertSearch = function (options) {
    var user_name = options.applicationOptions.user_name;
    var user = options.applicationOptions.user;
    var email = options.applicationOptions.email;

    this.models.search.input.set("count", 5, {silent: true});

    var el = $('#' + options.applicationOptions.el);
    if (user) {
      //hide userinformations
      $(el.find("input[name='notification_user']")).attr("user",user).parent().hide();
    }
    if (email) {
      //hide emailinformations
      $(el.find("input[name='notification_email']")).attr("email",email).parent().hide();
    }

    _.each(this.models.emailAlerts.get("frequency").models, function(fq) {
      var path = fq.path;
      var description = _.find(fq.get("property"), function(desc) { return desc.key == "displayname" }).value;
      $('#' + options.applicationOptions.el + " select").append($('<option>', {
        value: fq.get("path").join("/"),
        text: description
      }));
    });

    var uniq_groupTags = _.filter(_.map(_.uniq(this.models.emailAlerts.get("alerts").models, function(m){return m.get("groupTag");}), function(model){return model.get("groupTag")}), (function(tag){ return tag != undefined }) );
    var $notification_group_tag = $( "input[name='notification_group_tag']" );
    $notification_group_tag.autocomplete({
      source: uniq_groupTags,
      minLength: 0,
      appendTo: $notification_group_tag.parent()
    });

    if (options.applicationOptions.properties && ( options.applicationOptions.properties.edit || options.applicationOptions.properties.duplicate || options.applicationOptions.properties.subscribe) ) {

      if (options.applicationOptions.properties.subscribe) {
        var alert_query = options.applicationOptions.properties.model.get("data");
        this.models.search.input.set(Search.SearchRequest.parse(alert_query));
        var title = options.applicationOptions.properties.model.get("name");

        if (options.applicationOptions.properties.editSubscription) {
          var description_global = options.applicationOptions.properties.model.get("description");
          $(el.find("input[name='notification_title']")).val(description_global);
        }

      } else {

        if (options.applicationOptions.properties.referenced_notification_available) {
          var notification_reference = options.applicationOptions.properties.model.get("referenced_notification");
          var notification_model = _.find(this.models.emailAlerts.get("alert_presets") && this.models.emailAlerts.get("alert_presets").models, function(model) {
            return _.isEqual(notification_reference, model.get("path"))
          });

          if (notification_model) {
            var referenced_notification_query = notification_model.get("data");
            this.models.search.input.set(Search.SearchRequest.parse(referenced_notification_query));

          } else {
            //default query (reference not found)
            var alert_query = options.applicationOptions.properties.model.get("query");
            this.models.search.input.set(Search.SearchRequest.parse(alert_query));

          }
        } else {
          var retainViewSourceContextConstraints = this.options.retainViewSourceContextConstraints;
          this.options.retainViewSourceContextConstraints = true;
          var alert_query = options.applicationOptions.properties.model.get("query");
          this.models.search.input.set(Search.SearchRequest.parse(alert_query));
          this.options.retainViewSourceContextConstraints = retainViewSourceContextConstraints;
        }

        var groupTag = options.applicationOptions.properties.model.get("groupTag");
        var alertBase = options.applicationOptions.properties.model.get("path");
        var alertBasePath = alertBase[0] + "/" + alertBase[1];
        var title = options.applicationOptions.properties.model.get("description");
        $(el.find("select[name='notification_alert_base']")).val(alertBasePath);
        $(el.find("input[name='notification_group_tag']")).val(groupTag);
      }

      $(el.find("input[name='notification_description']")).val(title);

    } else {
      this.setUnparsedUserQuery(options.applicationOptions.userQuery);
    }
  };

  Application.prototype.createOrUpdateNotification = function (options) {
    if (options.event.handled) return;
    options.event.handled = true;
    var that = this;

    var el = $('#mb-add-notification-stack');

    if(!$("input[name='notification_description']").val()) {
      return;
    }

    function closeModal(that) {
      that.models.stack.pop();
    }

    var el = document.body;
    var selected_tab = this.models.tabs.getSelectedTabName();
    if (options.update) {
      var model = options.model;
      var description = $($(el).find("input[name='notification_title']")).val();
      var title = $($(el).find("input[name='notification_description']")).val();
      var query = this.models.search.input.toJSON();

      model.set("name", title);
      model.set("description", description);
      model.set("data", query);
      model.save(null, {
        success: function (model, response) {
          closeModal(that);
        },
        error: function (model, response) {
          //TODO error handling
        }
      });

    } else {
      var title = $($(el).find("input[name='notification_title']")).val();
      var description = $($(el).find("input[name='notification_description']")).val();
      var email = $($(el).find("input[name='notification_email']")).val() || $($(el).find("input[name='notification_email']")).attr("email");
      var groupTag = $($(el).find("input[name='notification_group_tag']")).val();
      var frequency = $($(el).find("select[name='notification_alert_base']")).val();
      var username = $($(el).find("input[name='notification_user']")).val() || $($(el).find("input[name='notification_user']")).attr("user");
      var query = this.models.search.input.toJSON();


      var applicationOptions = options.model && options.model.get("applicationOptions");

      var userModel = this.models.emailAlerts.get("user");
      try {
        // After creation of new user, it is located as the following
        userModel = this.models.emailAlerts.get("user").at(0);
      } catch(error) {
        // When user already exists
      }

      var userAlreadyExists = !!(userModel && userModel.get("properties"));
      var referenceId = '';
      var referenceQuery = {};

      if (options.userUpdate) {
        referenceQuery = options.model.get("query");
        var reference_notification_path = options.model.get("referenced_notification");
        if (_.isArray(reference_notification_path)) {
          referenceId = options.model.get("referenced_notification").join("/");
        } else {
          referenceId = options.model.get("referenced_notification");
        }
      } else if (applicationOptions && applicationOptions.properties && applicationOptions.properties.subscribe) {
        referenceQuery = applicationOptions.properties.model.get("data");
        referenceId = applicationOptions.properties.model.get("id");
      }

      var userChangedQuery = !_.isEqual(query.user, referenceQuery.user);
      // In case user changed the query when editing an existing alert
      if (userChangedQuery) {
        referenceId = '';
      }

      function createAlertModel (selected_tab, email, alertBase, description, title, groupTag, query, owner, reference_id) {
        var alertObj = {
          email: email,
          alertBase: alertBase,
          description: description,
          groupTag: groupTag,
          query: query,
          owner: owner,
          selected_tab: selected_tab
        };


        if (reference_id) alertObj.referenced_notification = reference_id;
        if (options.originalAlertCreationDate ) alertObj.created = options.originalAlertCreationDate ;
        return new AlertModels.AlertModel(alertObj);
      };

      var owner = this.models.emailAlerts.get("serviceInfo").userSourceInfo.get("user_name");

      // If user is not available create new user then add new alert
      var validUserFields = description && email && frequency && username;
      if (! userAlreadyExists && validUserFields) {
        var usermodel = this.models.emailAlerts.get("user");
        usermodel.add({
          properties: {
            user: username,
            email: email,
            active: "true"
          }
        });
      }

      frequency = frequency.split("/")[1];
      var subscription = createAlertModel(selected_tab, email, frequency, description, "", groupTag, query, owner, referenceId);
      this.models.emailAlerts.get("alerts").add(subscription);
      closeModal(this);
    }
  };

  Application.prototype.editUserAlert = function (options) {
    options.event.preventDefault();
    if(window.innerWidth <= 991 && !options.forceOpen) {
      this.toggleOpen(options);
      return;
    }
    options.edit = true;
    options.created = options.model.attributes.created;
    this.alertsStackManager(options);
  };

  Application.prototype.updateNotification = function (options) {
    var applicationOptions = options.model && options.model.get("applicationOptions");
    if (applicationOptions) {
      var alertModel = applicationOptions.properties.model;
      options.originalAlertCreationDate = alertModel.get("created");
      this.models.emailAlerts.get("alerts").remove(alertModel);
      this.createOrUpdateNotification(options);
    }
  };

  Application.prototype.duplicateUserAlert = function (options) {
    options.event.preventDefault();
    options.duplicate = true;
    this.alertsStackManager(options);
  };

  Application.prototype.shareUserAlert = function (options) {
    $(options.eventTarget.parentElement).toggleClass("active");
    var input = $(options.eventTarget.parentElement).find("input");
    input.focus();
    input.select();

    var toggleElement = function(e) {
      var isChild = $('.mb-alert-action-container').find(e.target).length;
      if ( !isChild ){
        $('body').unbind("click", toggleElement);
        $('.group-headline-edit').removeClass("active");
      }
    }
    $('body').on("click", toggleElement);
  };

  Application.prototype.deleteUserAlert = function (options) {
    var alertID = options.model.id;
    this.models.emailAlerts.getAlertWithPath(alertID, function (response) {
      var model = options.model;
      model.trigger('destroy', model, model.collection, options);
    }, function() {
      //...
    }, {splitSign: "/" });
  };

  Application.prototype.updateGlobalSubscription = function (options) {
    var applicationOptions = options.model && options.model.get("applicationOptions");
    if (applicationOptions) {
      var alertModel = applicationOptions.properties.model;
      options.update = true;
      options.model = alertModel;
      this.createOrUpdateNotification(options);
    }
  };

  Application.prototype.updateSubscription = function (options) {
    var applicationOptions = options.model && options.model.get("applicationOptions");
    if (applicationOptions) {
      var alertModel = applicationOptions.properties.model;
      this.models.emailAlerts.get("alerts").remove(alertModel);
      options.userUpdate = true;
      options.model = alertModel;
      this.createOrUpdateNotification(options);
    }
  };

  Application.prototype.createTemplate = function (options) {
    if (options.event.handled) return;
    options.event.handled = true;

    var that = this;

    this.models.emailAlerts.getSchemaByPath(["emailalert"], this, function (response) {
        var property_definitions = response && response.property_definitions;
        var referenced_notification = _.find(property_definitions, function (property) {
          return property.key == "referenced_notification";
        });

        var reference_target_collection_path = referenced_notification && referenced_notification.reference_target_collection_path;
        if (reference_target_collection_path) {
          var el = $('#mb-add-notification-stack');
          var description = $($(el).find("input[name='notification_title']")).val();
          var name = $($(el).find("input[name='notification_description']")).val();
          if (!description || !name) return;

          if (that.models.emailAlerts.get("alert_presets")) {
            var template = new AlertModels.GlobalAlertedSearchesModel({
              model: "GlobalAlertedSearchesModel",
              path: reference_target_collection_path,
              description: description,
              name: name,
              data: that.models.search.input.toJSON()
            });
            that.models.emailAlerts.get("alert_presets").add(template);
            that.models.stack.pop();
          }
        } 
      }, function() {}); //callback, errback?
  };

  EmailAlert.DEFAULT_TEMPLATE = DEFAULT_TEMPLATE && DEFAULT_TEMPLATE.default;

  return EmailAlert;
});
